<template>
  <!-- <div
    :class="['cms-content', { 'container': sync }]"
    v-if="getCmsData"
    v-html="getCmsData.content"
  /> -->
  <ul :class="ulClass">
    <li :class="liClass" v-for="(menuItem, index) in getCmsData" :key="index">
      <a :class="aClass" :target="getTarget(menuItem)" :href="getUrl(menuItem)">{{ menuItem.displayName }}</a>
    </li>
  </ul>
</template>

<script>
import config from 'config'
import RootCateogry from 'theme/mixins/rootCategory'
import { isOfficeShop } from 'theme/helpers'
export default {
  name: 'CmsBlockMenu',
  props: {
    id: {
      type: Number,
      default: null,
      required: false
    },
    identifier: {
      type: String,
      default: null,
      required: false
    },
    sync: {
      type: Boolean,
      default: false,
      required: false
    },
    liClass: {
      type: String,
      default: null,
      required: false
    },
    aClass: {
      type: String,
      default: null,
      required: false
    },
    ulClass: {
      type: String,
      default: null,
      required: false
    }
  },
  mixins: [RootCateogry],
  // asyncData ({ store, route, context }) {
  // @TODO to cover SSR need find a way to pass props identifier/id to the asyncData()
  // for now it is not possible but assuming from some info it could be available later
  // we try to dispatch 'single' action which actually dispatch list to prefetch data anyway

  /* return new Promise((resolve, reject) => {
    store.dispatch('cmsBlock/single', {
      value: this.identifier
    }).then(res => {
      return resolve(res)
    })
  }) */
  // },
  created () {
    let queryKey = ''
    let queryValue = ''
    if (this.id) {
      queryKey = 'id'
      queryValue = this.id
    } else if (this.identifier) {
      queryKey = 'identifier'
      queryValue = this.identifier
    }
    if (queryKey && queryValue) {
      this.$store.dispatch('cmsBlock/single', {
        key: queryKey,
        value: queryValue
      })
    }
  },
  computed: {
    getCmsData () {
      let __response = this.$store.getters[`cmsBlock/cmsBlockIdentifier`](
        this.identifier
      );
      if (__response) {
        const result = JSON.parse(__response.content).filter(e => {          
          if (typeof e.categorySlug === 'undefined') {
            return true;
          } else if (e.categorySlug !== this.getRootCategorySlug) {
            return false;
          }
          return true;
        });        
        return result
      }
      return [];
    }
  },
  methods: {
    getTarget (menuItem) {
      if (typeof menuItem.url === 'undefined') {
        return '_self';
      }
      if (menuItem.url.indexOf('http://') > -1) {
        return '_blank';
      }
      if (menuItem.url.indexOf('https://') > -1) {
        return '_blank';
      }
      return '_self'
    },
    getUrl (menuItem) {
      if (menuItem.linkType) {        
        let baseUrl = isOfficeShop() ? config.site.office_path : config.baseUrl
        baseUrl = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'
        return baseUrl + 'i/' + menuItem.slug
      }
      return menuItem.url;
    }
  }
}
</script>
